var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompetitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "driver"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8799 6.66676H3.12652C2.13985 6.66676 1.33984 5.8601 1.33984 4.8801V3.12676C1.33984 2.14009 2.14652 1.34009 3.12652 1.34009H12.8799C13.8665 1.34009 14.6665 2.14676 14.6665 3.12676V4.8801C14.6665 5.8601 13.8599 6.66676 12.8799 6.66676Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.8799 14.6668H3.12652C2.13985 14.6668 1.33984 13.8601 1.33984 12.8801V11.1268C1.33984 10.1401 2.14652 9.34009 3.12652 9.34009H12.8799C13.8665 9.34009 14.6665 10.1468 14.6665 11.1268V12.8801C14.6665 13.8601 13.8599 14.6668 12.8799 14.6668Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4 3.33325V4.66659",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.6665 3.33325V4.66659",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4 11.3333V12.6666",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.6665 11.3333V12.6666",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.3335 4H12.0002",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.3335 12H12.0002",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitor);
export default __webpack_public_path__ + "static/media/competitor.c278184c8d81ccd624029a0845ee5fae.svg";
export { ForwardRef as ReactComponent };